import { UploadWorkbookDialogValues } from '../components/UploadWorkbookDialog';

export namespace UploadWorkbookActionsTypes {
  export const START = 'UPLOAD_WORKBOOK_START';
}

export interface UploadWorkbookStartAction {
  readonly type: typeof UploadWorkbookActionsTypes.START;
  readonly data: UploadWorkbookDialogValues;
  readonly overwrite: boolean;
}

export function requestUploadWorkbookAction(args: Omit<UploadWorkbookStartAction, 'type'>): UploadWorkbookStartAction {
  return {
    type: UploadWorkbookActionsTypes.START,
    ...args
  };
}
